import { convertToForm } from "src/helpers";
import { store } from "src/store";

const baseUrl = process.env.REACT_APP_BASE_URL + "/";
const baseUrl2 = process.env.REACT_APP_BASE_URL2;
export const Get = (
  url,
  token = store?.getState()?.auth?.access_token,
  noBase = false
) => {
  const finalUrl = baseUrl + url;



  return fetch(noBase ? url : finalUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + token,
    },
  });
};

export const GetSearch = (
  url,
  token = store?.getState()?.auth?.auth_search?.access_token,
  noBase = false
) => {
  const finalUrl = baseUrl2 + url;
  return fetch(noBase ? url : finalUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + token,
    },
  });
};

export const Post = (
  url,
  payload = {},
  payloadType: "application/json" | "multipart/form-data" = "application/json",
  token = store?.getState()?.auth?.access_token,
  cBaseUrl = baseUrl
) => {

  const amaClientRef = store?.getState()?.amaClientRef?.clientRef || "";

  console.log("|||||||||||||||||||amaClientRef|||||||||||||||||||", amaClientRef);
  if (payloadType === "multipart/form-data") {
    return fetch(cBaseUrl + url, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        // "ama-client-ref": amaClientRef,
      },
      body: convertToForm(payload),
    });
  }
  return fetch(cBaseUrl + url, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + token,
      // "ama-client-ref": amaClientRef,
    },
    body: JSON.stringify(payload),
  });
};

export const Postx_www_form = (url, payload = {}) => {
  return fetch(baseUrl + url, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: payload as any,
  });
};

export const Postx_www_form_traveler = (url, payload = {}) => {
  return fetch(baseUrl2 + url, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: payload as any,
  });
};

export const Patch = (
  url,
  payload = {},
  token = store?.getState()?.auth?.access_token
) => {
  return fetch(baseUrl + url, {
    method: "PATCH",
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(payload),
  });
};

export const Delete = (
  url,
  payload = {},
  token = store?.getState()?.auth?.access_token
) => {
  return fetch(baseUrl + url, {
    method: "DELETE",
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(payload),
  });
};

const http = {
  Get,
  Post,
  Postx_www_form,
  Patch,
  Delete,
  GetSearch,
  Postx_www_form_traveler,
};
export default http;
